import React, { useState, useRef, useEffect } from "react"
import { TabView, TabPanel } from "primereact/tabview"
import {
    CardBody,
    Col,
    Container,
    Row,
    DropdownItem,
    DropdownMenu,
} from "reactstrap"
// import { Col, Row } from "reactstrap"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import "primereact/resources/themes/saga-blue/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { BreadCrumb } from "primereact/breadcrumb"
import { RadioButton } from "primereact/radiobutton"
import { Checkbox } from "primereact/checkbox"
import { Calendar } from "primereact/calendar"
import { MultiSelect } from "primereact/multiselect"
import { Accordion, AccordionTab } from "primereact/accordion"
import { Badge } from "primereact/badge"
import { TreeSelect } from "primereact/treeselect"
import { Editor } from "primereact/editor"
import { useForm } from "react-hook-form"
import { useLocation } from "react-router-dom"
import axios from "axios"
import moment from "moment"
import gdrive from "../../assets/images/google-drive.png"
import dropbox from "../../assets/images/dropbox.png"
import onedrive from "../../assets/images/one-drive.png"
import { Radius } from "lucide-react"
import Modal from "react-bootstrap/Modal";
import AdminDasboardats from "ATSComponents/Common/AdminDasboardats"
import { triggerAlert } from "utils/CommonFunctions"


const MyAccount = () => {

    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const initialTabIndex = Number(queryParams.get("selectedTab")) || 0
    const [currentTab, setCurrentTab] = useState(initialTabIndex)
    document.title = "ATS - MyAccount"

    useEffect(() => {
        setCurrentTab(initialTabIndex)
    }, [initialTabIndex])


    const {
        register: register1,
        formState: { errors: errors1 },
        handleSubmit: handleSubmit1,
        getValues: getValues1,
        setValue: setValue1,
        trigger: trigger1,
        reset: reset1,
    } = useForm({ mode: "onBlur" })


    const {
        register: register2,
        formState: { errors: errors2 },
        handleSubmit: handleSubmit2,
        getValues: getValues2,
        setValue: setValue2,
        trigger: trigger2,
        reset: reset2,
    } = useForm({ mode: "onBlur" })


    // My account start

    const [passwordData, setPasswordData] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    })
    const [showAlert, setShowAlert] = useState({
        show: false,
        message: "",
        type: "",
    })

    const [activeTab, setActiveTab] = useState(0)
    const [EmployeeImage1, setEmployeeImage1] = useState(localStorage.getItem('profileImage') || "");
    const [profileData, setProfileData] = useState({})

    const [error, setError] = useState("");

    const fetchmyaccount = async () => {
        var userInfo = JSON.parse(sessionStorage.getItem('atsuser-info'));
        try {
            const response = await axios.get(`/api/v1/users/${userInfo.user_details.user_id}/`)
            setProfileData(response.data)

            const currentPassword = response.data.watch_word;
            setOriginalPassword(currentPassword);
            setNewPasswordValue(currentPassword);

            if (response.data) {
                // Only set the image if it's not already a base64 uploaded image
                if (!EmployeeImage1 || !EmployeeImage1.startsWith('data:')) {
                    const storedImage = localStorage.getItem('profileImage');
                    if (storedImage) {
                        setEmployeeImage1(storedImage);
                    } else {
                        setEmployeeImage1(response.data.profile_image);
                    }
                }
            } else {
                if (!EmployeeImage1 || !EmployeeImage1.startsWith('data:')) {
                    const storedImage = localStorage.getItem('profileImage');
                    if (storedImage) {
                        setEmployeeImage1(storedImage);
                    } else {
                        setEmployeeImage1(response.data.profile_image);
                    }
                }
            }
            const deatilsacco = response.data



            setValue5("FirstName", deatilsacco.first_name)
            setValue5("MiddleName", deatilsacco.middle_name)
            setValue5("LastName", deatilsacco.last_name)
            setValue5("personalEmailOnB_P", deatilsacco.email)
            setValue5("phoneOnB_P", deatilsacco.phone_number)



        }
        catch (error) {

        }
    }
    useEffect(() => {
        fetchmyaccount();

    }, []);

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(",")[1]; // Remove data:... prefix
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });
    };

    const uploadimagetoServer1 = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Allow only PDF and JPG
        const allowedTypes = ["image/png", "image/jpeg"];
        if (!allowedTypes.includes(file.type)) {
            setError("Only png and JPG files are allowed.");
            return;
        }

        // Max size = 10MB
        const maxSize = 1 * 1024 * 1024;
        if (file.size > maxSize) {
            setError("File size should not exceed 1MB.");
            return;
        }

        setError(""); // Clear previous errors

        try {
            const base64 = await getBase64(file);

            const userInfo = JSON.parse(sessionStorage.getItem("atsuser-info"));
            const userId = userInfo?.user_details?.user_id;

            const req = {
                profile_image_filename: file.name,
                profile_image_base64: base64,
            };

            const response = await axios.put(`/api/v1/users/${userId}/`, req);

            if (response.data) {
                // Set the image immediately for display using base64
                const base64Image = `data:${file.type};base64,${base64}`;
                setEmployeeImage1(base64Image);
                // Update profileData to keep the image in state
                setProfileData(prev => ({ ...prev, profile_image: base64Image }));
                // Store in localStorage to persist across navigation
                localStorage.setItem('profileImage', base64Image);
                // fetchmyaccount(); // Removed to prevent overwriting with URL that may not load
                // window.location.reload();
            }

        } catch (err) {
            // setError("Failed to upload file.");
        }
    };

    const [isEditingPassword, setIsEditingPassword] = useState(false);
    const [newPasswordValue, setNewPasswordValue] = useState(""); // Editable password value
    const [showPasswordInput, setShowPasswordInput] = useState(false);
    const [originalPassword, setOriginalPassword] = useState(""); // To store original password
    const [passwordError, setPasswordError] = useState("");
    const [successMatch, setsuccessMatch] = useState(false);
    const [showPassword, setShowPassword] = useState(false)
    const togglePassword = () => setShowPassword(prev => !prev);
    const handlePasswordEditToggle = async (e) => {
        e.preventDefault();

        if (isEditingPassword) {


            const password = newPasswordValue;
            const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/;

            if (!regex.test(password)) {
                setPasswordError("Password must be 8–16 characters, with at least one digit, one lowercase, and one uppercase letter.");
                return;
            }



            try {
                const req = { password: newPasswordValue };

                const userInfo = JSON.parse(sessionStorage.getItem("atsuser-info"));
                const userId = userInfo?.user_details?.user_id;

                const response = await axios.put(`/api/v1/users/${userId}/`, req, {

                });
                fetchmyaccount()
                setOriginalPassword(newPasswordValue); // update local reference
                setIsEditingPassword(false);
                setShowPasswordInput(false);
                setsuccessMatch(true)
            } catch (error) {


            }
        } else {
            // ✅ Enter edit mode and show password
            setNewPasswordValue(originalPassword); // Set value for editing
            setIsEditingPassword(true);
            setShowPasswordInput(true);

        }
    };

    // const onloadaccount = (data) => {

    //     setValue5()

    // }

    const [visibleaccount, setvisibleaccount] = useState(false)
    const { register: register5, formState: { errors: errors5 }, handleSubmit: handleSubmit5, getValues: getValues5, setValue: setValue5, trigger: trigger5, reset: reset5, } = useForm({ mode: "onBlur" });

    const jobnotereq = async (data) => {

        const userInfo = JSON.parse(sessionStorage.getItem("atsuser-info"));
        const userId = userInfo?.user_details?.user_id;

        const req = {
            first_name: data.FirstName,
            middle_name: data.MiddleName,
            last_name: data.LastName,
            email: data.personalEmailOnB_P,
            phone_number: data.phoneOnB_P,
        };


        try {
            var notespost = await axios.put(`/api/v1/users/${userId}/`, req);
            if (notespost.data) {
                fetchmyaccount()
                setvisibleaccount(false)
                setsuccessMatch(true)
            }
        } catch (error) {
            setvisibleaccount(false)
            triggerAlert("error", "Error", error?.response?.data?.error || "Failed to update.");

        };
    }

    return (
        <React.Fragment>
            <Container fluid={true}>

                <div className="tabsmargin">
                    <AdminDasboardats />
                    <div className="container-fluid">
                        {showAlert.show && (
                            <div
                                className={`alert ${showAlert.type === "error"
                                    ? "alert-error"
                                    : "alert-success"
                                    }`}
                            >
                                {showAlert.message}
                            </div>
                        )}
                        <div className="profile-preview-container">
                            {/* <PasswordDialog /> */}
                            {/* <PhotoDialog /> */}

                            {/* Profile Header */}
                            <div className="profile-header">
                                <div className="profile-header-content">
                                    <div className="profile-image-container">
                                        {EmployeeImage1 ? (
                                            <div className='preview_img'>
                                                <div className='main_img'>
                                                    <picture>
                                                        <img
                                                            src={EmployeeImage1}
                                                            id='preview'
                                                            className='preview'
                                                            alt='No Image Selected'
                                                        />
                                                    </picture>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className='preview_img'>
                                                <div className='main_img'>
                                                </div>
                                            </div>
                                        )}
                                        <div className="profile-image-container">
                                            <form action="#" method="post">
                                                <div>
                                                    <label className="change-photo-btn" htmlFor="pdfUpload">
                                                        <i className="pi pi-pencil"></i>
                                                    </label>
                                                    <input
                                                        className="imgHidden"
                                                        id="pdfUpload"
                                                        type="file"
                                                        accept=".png, .jpg, .jpeg"
                                                        onChange={uploadimagetoServer1}
                                                        onClick={(e) => {
                                                            e.target.value = null;
                                                        }}
                                                        style={{ display: "none" }}
                                                    />
                                                </div>
                                            </form>

                                        </div>
                                        {error && <p style={{ color: "red" }}>{error}</p>}
                                    </div>
                                    <div>
                                        <h1 className="profile-name">
                                            {`${profileData.first_name || "-"} ${profileData.middle_name || ""} ${profileData.last_name || "-"}`}
                                        </h1>
                                        <p className="profile-role">{profileData.department_name || "-"}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Tabs */}
                            <div className="tabs">
                                <button onClick={() => setActiveTab(0)}
                                    className={`tab-btn ${activeTab === 0 ? "active-tab" : ""}`}
                                >
                                    Profile Information
                                </button>
                            </div>

                            {/* Profile Content */}
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <button className="change-btn" onClick={() => { reset5(""); setvisibleaccount(true); fetchmyaccount() }}><i class="pi pi-pencil"></i></button>
                            </div>

                            <div className="profile-content">

                                <div className="profile-grid">
                                    {/* Left Column */}
                                    <div className="left-column">
                                        <div className="mb-3">
                                            <label>First Name</label>
                                            <input
                                                type="text"
                                                value={profileData.first_name}
                                                disabled
                                                className="profile-input"
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label>Middle Name</label>
                                            <input
                                                type="text"
                                                value={profileData.middle_name}
                                                disabled
                                                className="profile-input"
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label>Last Name</label>
                                            <input
                                                type="text"
                                                value={profileData.last_name}
                                                disabled
                                                className="profile-input"
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label>Email</label>
                                            <input
                                                type="email"
                                                value={profileData.email}
                                                disabled
                                                className="profile-input"
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label>Mobile Number</label>
                                            <input
                                                type="tel"
                                                value={profileData.phone_number}
                                                disabled
                                                className="profile-input"
                                            />
                                        </div>

                                        <div className="mb-3 d-none">
                                            <label>Change Password<span class="text-danger">*</span></label>

                                            <div className="password-container">
                                                <input
                                                    type={showPasswordInput ? "text" : "password"}
                                                    value={isEditingPassword ? newPasswordValue : "********"}
                                                    disabled={!isEditingPassword}
                                                    className="profile-input"
                                                    onChange={(e) => { setPasswordError(""); setNewPasswordValue(e.target.value) }}
                                                />

                                                <button
                                                    type="button"
                                                    onClick={handlePasswordEditToggle}
                                                    className="change-btn"
                                                >
                                                    <i className={`pi ${isEditingPassword ? "pi-check" : "pi-pencil"}`}></i>
                                                </button>

                                            </div> {passwordError && (
                                                <small className="text-danger d-block mt-1">{passwordError}</small>
                                            )}
                                        </div>
                                    </div>

                                    {/* Right Column */}
                                    <div className="right-column">
                                        <div className="mb-3 d-none">
                                            <label>Username</label>
                                            <input
                                                type="text"
                                                value={profileData.user_id}
                                                disabled
                                                className="profile-input"
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label>Roles and Permission</label>
                                            <input
                                                type="text"
                                                value={profileData.role_name}
                                                disabled
                                                className="profile-input"
                                            />
                                        </div>
                                        {/* <div className="mb-3">
                                            <label>Linked Contact</label>
                                            <input
                                                type="text"
                                                value={profileData.linkedContact}
                                                disabled
                                                className="profile-input"
                                            />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
            <Dialog header={`Account`} visible={visibleaccount} onHide={() => setvisibleaccount(false)}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} className="link-candidates">
                <form onSubmit={handleSubmit5(jobnotereq)}>
                    <Row>
                        <Col lg={12}>
                            <div className="profile-grid">

                                {/* First Name */}
                                <div className="mb-3">
                                    <label className="form-label">First Name <span className="text-danger">*</span></label>
                                    <InputText
                                        className="form-control"
                                        {...register5("FirstName", {
                                            required: "This field is required",
                                            pattern: {
                                                value: /^[A-Za-z][A-Za-z-\s]+$/,
                                                message: "Please enter a valid first name",
                                            },
                                        })}
                                        onKeyUp={() => trigger5("FirstName")}
                                    />
                                    {errors5.FirstName && <small className='text-danger font-bold'>{errors5.FirstName.message}</small>}
                                </div>

                                {/* Middle Name */}
                                <div className="mb-3">
                                    <label className="form-label">Middle Name</label>
                                    <InputText
                                        className="form-control"
                                        {...register5("MiddleName", {
                                            // required: "This field is required",
                                            pattern: {
                                                value: /^[A-Za-z][A-Za-z-\s]+$/,
                                                message: "Please enter a valid Middle name",
                                            },
                                        })}
                                        onKeyUp={() => trigger5("MiddleName")}
                                    />
                                    {errors5.MiddleName && <small className='text-danger font-bold'>{errors5.MiddleName.message}</small>}
                                </div>

                                {/* Last Name */}
                                <div className="mb-3">
                                    <label className="form-label">Last Name </label>
                                    <InputText
                                        className="form-control"
                                        placeholder="Enter Last Name"
                                        {...register5("LastName", {
                                            // required: "This field is required",
                                            pattern: {
                                                value: /^[A-Za-z][A-Za-z-\s]+$/,
                                                message: "Please enter a valid Last name",
                                            },
                                        })}
                                        onKeyUp={() => trigger5("LastName")}
                                    />
                                    {errors5.LastName && <small className='text-danger font-bold'>{errors5.LastName.message}</small>}
                                </div>

                                {/* Email */}
                                <div className="mb-3">
                                    <label className="form-label">Email <span className="text-danger">*</span></label>
                                    <InputText
                                        className="form-control"
                                        placeholder="Enter Email"
                                        {...register5("personalEmailOnB_P", {
                                            required: "Please enter Personal Email",
                                            pattern: {
                                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.com$/,
                                                message: "Please enter a valid email ID",
                                            },
                                            onChange: (e) => e.target.value = e.target.value.toLowerCase()
                                        })}
                                        onKeyUp={() => trigger5("personalEmailOnB_P")}
                                    />
                                    {errors5.personalEmailOnB_P && <small className='text-danger font-bold'>{errors5.personalEmailOnB_P.message}</small>}
                                </div>

                                {/* Mobile Number */}
                                <div className="mb-3">
                                    <label className="form-label">Mobile Number </label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        placeholder='Phone'
                                        autoComplete="off"
                                        {...register5("phoneOnB_P", {
                                            // required: "This Field Is Required",
                                            pattern: {
                                                value: /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/,
                                                message: "Please enter a valid mobile number.",
                                            },
                                            minLength: {
                                                value: 10,
                                                message: "Please Enter Min and Max 10 digits ",
                                            },
                                            maxLength: {
                                                value: 10,
                                                message: "Please Enter Min and Max 10 digits ",
                                            },
                                        })}
                                        onKeyUp={() => trigger5("phoneOnB_P")}
                                    />
                                    {errors5.phoneOnB_P && <small className='text-danger'>{errors5.phoneOnB_P.message}</small>}
                                </div>

                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Button type="submit" color="primary" className="btn btn-primary  waves-light me-2 sidebarbtn">
                                Save
                            </Button>
                        </Col>
                    </Row>

                </form>
            </Dialog>
            <Modal size="md" show={successMatch} onHide={() => setsuccessMatch(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 "> Success</h1></Modal.Header>
                <div className="text-center m-3"> </div>
                <h4 className="text-center">Account Updated Successfully </h4>
                <div className="text-center m-3">
                    <button className="btn btn-primary" onClick={() => setsuccessMatch(false)} > OK </button>
                </div>
            </Modal>

        </React.Fragment>

    )
}

export default MyAccount;
